import { render, staticRenderFns } from "./CustomerReviewPod.vue?vue&type=template&id=d9735e0e&scoped=true"
import script from "./CustomerReviewPod.vue?vue&type=script&lang=js"
export * from "./CustomerReviewPod.vue?vue&type=script&lang=js"
import "./CustomerReviewPod.vue?vue&type=style&index=0&id=d9735e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9735e0e",
  null
  
)

export default component.exports